import React, { useState } from 'react';
import { withStyles, Button, LinearProgress } from '@material-ui/core';
import classnames from 'classnames';
import DatePicker from '../../../components/DatePicker';

// SERVICES
import { getIQSurveyReportsZip } from '../../../services';

const styles = theme => ({
  datePicker: {
    padding: 10,
  },
});

export const IQSurveyResults = withStyles(styles)(props => {
  const { classes } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [error, setError] = useState('');

  const datesMissing = !startDate || !endDate;
  const dateRangeInvalid = !datesMissing && startDate >= endDate;
  const formInvalid = datesMissing || dateRangeInvalid;

  const getReportAsync = async () => {
    setError('');

    try {
      setIsGeneratingReport(true);
      await getIQSurveyReportsZip({ startDate, endDate });
    } catch (error) {
      setError(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const validationMessage = dateRangeInvalid ? 'Start date must be before the end date.' : '';

  return (
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch', 'card', 'border-left-green')}>
      <h3 style={{ marginBottom: 36 }}>
        Select a date range to generate and download the IQ Survey Results report for that time.
      </h3>

      <div className={classnames('flex-col')}>
        <div className={classnames('row-between-center')}>
          <div className={classnames('row-center-center')}>
            <div className={classnames('col-start-start')} style={{ marginRight: 10 }}>
              <span className={classnames('text-left')}>From:</span>
              <DatePicker selected={startDate} onChange={setStartDate} className={classes.datePicker} />
            </div>
            <div className={classnames('col-start-start')} style={{ marginLeft: 10 }}>
              <span className={classnames('text-left')}>Through:</span>
              <DatePicker selected={endDate} onChange={setEndDate} className={classes.datePicker} />
            </div>
          </div>

          <Button
            variant="contained"
            style={{ backgroundColor: formInvalid ? '#aaa' : 'var(--jmi-blue)', color: 'white', marginLeft: 24 }}
            onClick={getReportAsync}
            disabled={formInvalid || isGeneratingReport}
          >
            Get Report
          </Button>
        </div>

        <div style={{ width: '100%', marginTop: 24 }}>
          <div
            style={{
              visibility: isGeneratingReport ? 'visible' : 'hidden',
            }}
          >
            <LinearProgress />
          </div>
          <div style={{ maxWidth: 400, color: 'red' }}>{error || validationMessage}</div>
        </div>
      </div>
    </div>
  );
});
